export default " <div class=gw-form-country ng-form=$ctrl.usaStateField> <md-input-container class=md-block> <label>{{ ::$ctrl.label }}</label> <md-select ng-model=$ctrl.usaState ng-disabled=$ctrl.disabled ng-change=$ctrl.onChange.emit($ctrl.usaState) md-on-open=$ctrl.onShow(true) md-on-close=$ctrl.onShow(false) placeholder=\"Select State\"> <md-option ng-value=iso ng-repeat=\"(iso, state) in $ctrl.usaStates\"> {{ state }} </md-option> </md-select> <div class=md-hint ng-if=::$ctrl.hint> {{ ::$ctrl.hint }} </div> </md-input-container> </div> ";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/common/forms/usa-state/usa-state.html
// module id = HbyF
// module chunks = 1